import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faThumbsUp,
  faComment,
} from "@fortawesome/free-solid-svg-icons";

const StatsOverview = ({ post = null }) => {
  const { t } = useTranslation();

  if (post === null) {
    post = {
      stats: [
        {
          views: 0,
          likes: 0,
          comments: 0,
        },
      ],
    };
  }

  if (!post?.stats?.length) return null; // early exit if no stats

  const latest = post.stats.at(-1);

  return (
    <>
      <span style={{ fontSize: "smaller" }}>
        <FontAwesomeIcon icon={faEye} /> {latest.views}{" "}
        <FontAwesomeIcon icon={faThumbsUp} className="ms-3" /> {latest.likes}{" "}
        <FontAwesomeIcon icon={faComment} className="ms-3" /> {latest.comments}
      </span>
      <hr />
    </>
  );
};

export default StatsOverview;
